import { useContext, useState } from "react";
import styles from "./styles.module.css";
import CampoSelect from "../Campo/CampoSelect";
import { UserContext } from "../../context/UserContext";
import VerificaForm from "../../controllers/VerificaForm";
import Campo from "../Campo";
import { PlanoDeTrabalho } from "../../model/PlanoDeTrabalho";
import putPlanoTrabalho from "../../services/putPlanoTrabalho";

type Props = {
  planoObj: any;
  setPlano: React.Dispatch<React.SetStateAction<PlanoDeTrabalho>>;
  closeModal: Function;
};

const EditSituacaoPlanoTrabalho = ({ planoObj, setPlano, closeModal }: Props) => {
  const [situacaoPlano, setSituacaoPlano] = useState(planoObj.situacao);
  const [observacaoPlano, setObservacaoPlano] = useState(situacaoPlano != "Rejeitado"? "" : planoObj.observacao);

  const { token } = useContext(UserContext);

  const salvarDados = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const editarPlanoTrabalho = async () => {
      try {
        const r = await putPlanoTrabalho(token, planoObj.id, situacaoPlano, situacaoPlano != "Rejeitado"? "Sem observações" : observacaoPlano);    
        setPlano({
          id: planoObj.id,
          titulo_projeto: planoObj.titulo_projeto,
          edital_id: planoObj.edital_id || undefined,
          modalidade: planoObj.modalidade,
          orgao_financiador: planoObj.orgao_financiador,
          objeto_parceria: planoObj.objeto_parceria,
          area_atendimento: planoObj.area_atendimento,
          inicio: planoObj.inicio,
          fim: planoObj.fim,
          situacao: r.situacao || situacaoPlano,
          descricao_realidade: planoObj.descricao_realidade,
          observacao: planoObj.observacao,
          forma_execucao: planoObj.forma_execucao,
          descricao_metas: planoObj.descricao_metas,
          indicadores: planoObj.indicadores,
          manutencao_equipamentos: planoObj.manutencao_equipamentos
        })
        
      } catch (err) {
        console.log("Erro ao editar situação do Plano de Trabalho ", err);
      }
    };
    if (VerificaForm(e.currentTarget.form)) {
      editarPlanoTrabalho();
      closeModal();
    }
  }; 

  return (
    <form className={styles.formModal} onSubmit={salvarDados}>
      <h2>Alterar situação da Proposta</h2>
      <div className={styles.camposDados}>
        <hr />
        <div className={styles.gridCampos}>
          <span className={styles.tuplaDado}>
            <strong>Título da Proposta:</strong> {planoObj.titulo_projeto}
          </span>
          <span className={styles.tuplaDado}>
            <strong>Modalidade da Proposta:</strong> {planoObj.modalidade}
          </span>
        </div>
        <hr />
        <div className={styles.gridCampos}>
        <CampoSelect title="Situação" setter={setSituacaoPlano} value={situacaoPlano}>
          <option value="Pendente">Pendente</option>
          <option value="Aceito">Aceito</option>
          <option value="Rejeitado">Rejeitado</option>
        </CampoSelect>
        {situacaoPlano == "Rejeitado" && 
        <Campo
            title="Observação"
            type="text"
            placeholder="Motivo da reprovação"
            required={true}
            value={observacaoPlano}
            setter={setObservacaoPlano}
            customValidity="Preencha a observação para a rejeição da Proposta"
          ></Campo>
        }
        </div>
        <hr />
      </div>
      <input type="submit" value="Editar Situação" />
    </form>
  );
};

export default EditSituacaoPlanoTrabalho;
